import React from 'react'

import Icon from 'app/app/(client)/components/atoms/Icon/Icon'
import Text from 'app/app/(client)/components/atoms/Text/Text'

interface PillBoxProps {
  id: string
  label: string
  onRemove?: () => void
  variant?: 'small' | 'medium' | 'large'
  className?: string
  disabled?: boolean
}

const PillBox: React.FC<PillBoxProps> = ({
  id,
  label,
  onRemove = () => null,
  variant = 'medium',
  className,
  disabled = false
}) => {
  // Compose className based on variant and disabled
  const variantClass = {
    small: 'pillbox--small',
    medium: 'pillbox--medium',
    large: 'pillbox--large'
  }[variant]
  const disabledClass = disabled ? 'opacity-50 cursor-not-allowed' : ''
  const composed = ['pillbox', variantClass, disabledClass, className].filter(Boolean).join(' ')

  return (
    <div id={id} className={composed} aria-disabled={disabled}>
      <Text className="text-primary font-semibold not-italic">{label}</Text>
      {onRemove && (
        <button
          id={id ? `${id}-remove-button` : ''}
          type="button"
          onClick={onRemove}
          aria-label="Remove"
          disabled={disabled}
          tabIndex={disabled ? -1 : 0}
        >
          <Icon name="icon-close-cross" className={`cursor-pointer ${disabled ? 'opacity-50' : ''}`} />
        </button>
      )}
    </div>
  )
}

export default PillBox
